import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { MessageService, Message, ConfirmationService } from 'primeng/api';

import { CaseService } from '../../services/case.service';
import { DictionaryService } from '../../services/dictionary.service';
import { UtilitiesService } from '../../services/utilities.service';
import { ApplicationFactsDto} from './dto/application-facts.dto';


@Component({
  selector: 'app-case-facts',
  templateUrl: './case-facts.component.html'
})
export class CaseFactsComponent implements OnInit, AfterViewInit {

    @Input() caseId: string;

    @Output() changeEvent = new EventEmitter();

    @ViewChild('fList1', { static: false}) fList: ElementRef;

    factsChoiceList: any[];// ApplicationFactsDto[];
    myFacts: any[];  // array of strings, representing the "Facts"
    claimRefund: string;
    requestFinding: string;

    myEmitObject: any;  // composit object emitted whenever data in this component changes

    someFactText: string;
    displayState = {
        factDiv: false,
        workingDiv: false,
        errorMessage: '',
    }; // for showing/hiding divs
    isNewEntry: boolean = false;

    constructor(private caseService: CaseService, private utilService: UtilitiesService, private dictService: DictionaryService,
        private messageService: MessageService, private confirmationService: ConfirmationService) { }

  ngOnInit() {
      this.myFacts = [];
      this.someFactText = '';
      this.loadFactsDictionary();
      if (this.caseId) {
        this.getCaseFacts();  // get FACTS associated w/ this case (if not New)
      } else {
          this.claimRefund = 'No';
          this.requestFinding = 'No';
          this.dataChange();
      };
    }
    ngAfterViewInit() {
        console.log('Values on ngAfterViewInit():');
        console.log("fList:", this.fList);
      }

    isAdministrator() {
        return true;
    }

  // this method executed whenever any data in the component is changed; it should trigger an event defined on the PARENT component
  dataChange() {
    this.utilService.doAudit(this.myFacts, 'Facts data changed');
    this.updateEmitObject();   // create composite object
    this.changeEvent.emit(this.myEmitObject); // transmit ALL values
    this.utilService.doAudit(this.myEmitObject, 'emitted composite object:');
  }

  // update composite FACTS object, for trasmission to Parent component (via event emitter)
  updateEmitObject() {
      this.myEmitObject = {
          factsList: this.myFacts,
          claimRefund: this.claimRefund,
          requestFinding: this.requestFinding
      }
    }

    // get dictionary of available FACTS
    loadFactsDictionary() {
        this.dictService.getFactsList().subscribe(data => {
            this.utilService.doAudit(data, 'facts dictionary in child component:');
            this.factsChoiceList = data;
            this.factsChoiceList.unshift({id: 0, letter: '', fact: ''});   // add blank at START of array
        });
    }

    // get the FACTS currently assigned to case
    getCaseFacts() {
        this.caseService.getCaseFacts(this.caseId).subscribe(data => {
            if (data) {
                this.utilService.doAudit(data, 'case Facts:');
                this.myFacts = data;
                this.dataChange(); // to force a data change on the parent
            }
            // now get some fields stored in the Case record...
            this.caseService.getCase(this.caseId).subscribe(data => {
                this.utilService.doAudit(data, 'getting Case data in FACTS module:');
                this.requestFinding = data.requestFinding === true? 'Yes': 'No';
                this.claimRefund = data.claimRefund === 'true' ? 'Yes' : data.claimRefund; // ONLY convert 'true' values to 'Yes' - rod 12/6/2025
                this.dataChange();
            })
        });
    }

    addFact(aFact) {
        this.utilService.doAudit(aFact, 'adding Fact:')
        if (aFact === '' || aFact === undefined || aFact === null) {
            return;
        }
        // *** NOTE:  some FACTS have added spaces so, they won't match what's in the dictionary!
        this.utilService.doAudit(this.myFacts, 'current list of FACTS:');
        let ind = this.myFacts.indexOf(aFact);
        this.utilService.doAudit(ind, 'index in array:');
        if (ind < 0) {
            this.myFacts.push(aFact);
            this.dataChange();
        } else {
            this.showToast({ key: 'infoFacts', severity: 'info', detail: 'FACT is already defined for this case', summary: 'Info' });
        }
        this.someFactText = '';
        let selEl = this.fList.nativeElement as HTMLSelectElement;
        selEl.selectedIndex = -1;   // clear the selection
        //this.utilService.doAudit(selEl,'addFact - fList1:');
    };

    removeFact(index) {
        this.utilService.doAudit(index, 'removing FACT w/ index:');
        let ind = this.myFacts.indexOf(index);
        this.utilService.doAudit(ind, 'index in array:');
        if (ind > -1) {
            this.myFacts.splice(ind, 1);
        }
        this.utilService.doAudit(this.myFacts, 'new array:');
        this.dataChange();
    };

  // Toaster/Message-related methods
  showToast(msg: Message) {
    this.messageService.clear('toastFacts');
    this.messageService.add(msg);
  }

  showInfo(myMsg: Message) {
    this.messageService.clear('infoFacts');
    this.messageService.add(myMsg);
  }

  showConfirm() {
      this.messageService.clear('conf');
      this.messageService.add({key: 'conf', sticky: true, severity: 'warn', summary: 'Are you sure?', detail: 'Confirm to proceed'});
  }

  onConfirm() {
      this.messageService.clear('conf');
  }

  onReject() {
      this.messageService.clear('conf');
  }

  clearAll() {
    this.messageService.clear();
  }

}
